import Component from '@Component';
import runInView from '@Core/utility/runInView';

export default class InViewAni extends Component {
  static selector = '[data-ani]'

  constructor(animatedEl) {
    super(animatedEl);
    this.count = Number(animatedEl.dataset.aniCount) || 1;
    runInView(this.$container, () => this.animate(), { count: this.count });
    this.$container.dataset.aniState = 'paused';

    this.$state = {
      play: 'start',
    };

    if (this.$container.dataset.aniOut) {
      this.observeMutation();
    }
  }

  animate(direction) {
    this.boundOnAnimationEnd = e => this.onAnimationEnd(e);
    this.$container.addEventListener('animationend', this.boundOnAnimationEnd);
    this.start(direction);
  }

  onAnimationEnd(e) {
    if (e.target !== this.$container) return;
    this.$container.removeEventListener('animationend', this.boundOnAnimationEnd);
    this.$container.classList.remove('ani-animate');
    this.$state.play = this.$state.play === 'running:out' ? 'paused' : 'done';
    this.$container.dataset.aniState = this.$state.play;
  }

  start(direction = 'running') {
    this.$state.play = direction;
    this.$container.dataset.aniState = this.$state.play;
    this.$container.classList.add('ani-animate');
  }

  observeMutation() {
    this.mutationObserver = new MutationObserver(([mutationsList]) => {
      if (mutationsList.type === 'attributes' && mutationsList.attributeName === 'data-ani-state') {
        if (mutationsList.target.dataset.aniState === 'running:out' && mutationsList.oldValue === 'done') {
          this.animate(this.$container.dataset.aniState);
        }
      }
    });
    this.mutationObserver.observe(this.$container, { attributes: true, attributeOldValue: true });
  }
}
